import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import LoadingBar from 'react-redux-loading-bar'

import { toggleSideView, movePageIndex } from '../actions'

import _ from 'lodash'
import { Flex } from 'react-flex'
import 'react-flex/index.css'

import './header.css'

import { getUrl } from '../utils/network'

class Header extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pageIndex: this.props.currentIndex,
        }
        this.movePage = _.debounce(this.movePage, 500)
        this.handle = 0
    }

    componentWillReceiveProps(newProps) {
        if (newProps.currentIndex !== this.state.pageIndex) {
            this.setState({
                pageIndex: newProps.currentIndex,
            })
        }
    }

    updatePage(pageValue) {
        this.setState({
            pageIndex: Number(pageValue - 1)
        })

        this.movePage(pageValue)
    }

    movePage(pageValue) {
        this.moveIndex(pageValue - 1)
    }

    moveFirst() { this.moveIndex(0) }
    movePrev() { this.moveIndex(this.state.pageIndex-1) }
    moveNext() { this.moveIndex(this.state.pageIndex+1) }
    moveLast() { this.moveIndex(this.props.totalPage-1) }

    moveIndex(index) {
        if (index < 0) {
            index = 0
        } else if (index >= this.props.totalPage - 1) {
            index = this.props.totalPage - 1
        }

        this.setState({
            pageIndex: index,
        })
        if (!isNaN(index) && index !== this.props.currentIndex) {
            this.props.movePageIndex(index)
        }
    }

    renderIndexButton() {
        return <img className="PageButton" onClick={this.props.toggleSideView} alt="SideView" src={require("../image/list_icon_n.png")} />
    }

    renderDownloadButton() {
       
        if (this.props.handle > 0) {
            let downloadUrl = getUrl("/pdmdownload") + "?handle=" + this.props.handle
             console.log("url "+ downloadUrl)
            return ( <a href={downloadUrl} download="pdmfile.pdm"> 
                        <img className="PageButton Download" alt="downlaodDoc" src={require("../image/save_ico_s.png")} />
                    </a>)
        }
    }

    render() {
        return (
            <div className="no-print">
                <Flex row className="Header">
                  {/* <div className="Header-Left">
                    { this.renderIndexButton() }
                  </div> */}
                  <div className="Header-Center">
                    <img className="PageButton" onClick={(e) => this.moveFirst()} alt="FirstPage" src={require("../image/first_ico_n.png")} />
                      <img className="PageButton" onClick={(e) => this.movePrev()} alt="PrevPage" src={require("../image/pre_ico_n.png")} />
                    <span className="text">Page</span>
                    <input type="number" className="pageInput" value={Number(this.state.pageIndex+1)} onChange={(e) => this.updatePage(e.target.value)} />
                    <span className="text">of</span>
                    <span className="text">{this.props.totalPage}</span>
                    <img className="PageButton" onClick={(e) => this.moveNext()} alt="NextPage" src={require("../image/next_ico_n.png")} />
                    <img className="PageButton" onClick={(e) => this.moveLast()} alt="LastPage" src={require("../image/last_ico_n.png")} />
                  </div>
                  {/* <div className="Header-Right">
                    {this.renderDownloadButton()}
                  </div> */}
                </Flex>
                <LoadingBar updateTime={200} progressIncrease={5} style={{height: '6px', background: '#00c4d0'}} />
            </div>
        );
    }
}

Header.propTypes = {
    showSideView: PropTypes.bool.isRequired,

    totalPage: PropTypes.number,
    currentIndex: PropTypes.number,
    
    toggleSideView: PropTypes.func,
    movePageIndex: PropTypes.func,
    handle : PropTypes.number,
}

function mapStateToProps(state) {
    const { extra, viewer } = state
    const { openStatus } = viewer

   

    let totalPage = openStatus.pageInfo === undefined || openStatus.pageInfo.cd !== '0000' ? 0 : openStatus.pageInfo.data.pageCount
    let docHandle = openStatus.fileInfo === undefined ? 0 : openStatus.fileInfo.handle

    return {
        showSideView: extra.showSideView,
        totalPage: totalPage,
        currentIndex: viewer.index,
        handle: docHandle
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleSideView: () => dispatch(toggleSideView()),
        movePageIndex: (index) => dispatch(movePageIndex(index)),
    }
}

export default connect (mapStateToProps, mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./src/containers/header.js